import { UserSession } from '../config/UserSession';
import { useConfigSlice } from '../store/slices/config/selectors';

import { getLobbyURL, type ILobbyURLOptions } from './helpers/getLobbyUrl';

export const useLobbyURLConnected = (options?: ILobbyURLOptions, overrideParams?: Record<string, string>): string => {
  const lobbyVersion = useConfigSlice.casinoConfig()?.lobbyVersion;
  const searchParams = UserSession.toURLSearchParams();

  if (overrideParams)
    Object.entries(overrideParams).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

  return getLobbyURL(lobbyVersion, '?' + searchParams.toString(), options);
};
